import { createContext, useRef } from "react";

export const Data = createContext(null)
export const ModalContext = createContext(null)

export const ModalProvider = ({children}) => {
	const modal = useRef(null)

	const toggleModal = () => {
		if (modal.current.open) {
			modal.current.close()
		} else {
			modal.current.showModal()
		}
	}
	return (
		<ModalContext.Provider value={[modal, toggleModal]}>
			{children}
			<dialog ref={modal} className="modal"></dialog>
		</ModalContext.Provider>
	)
}